/**
* Profile
* @namespace gplans.survey.services
*/
(function () {
  'use strict';

  angular.
  module('gplans.survey.services').
  factory('Survey', Survey);

  Survey.$inject = ['$http', '$q', '$rootScope', '$analytics', 'gplansConf', '$localStorage'];

  /**
                                                                                               * @namespace Survey
                                                                                               */Survey.$inject = ["$http", "$q", "$rootScope", "$analytics", "gplansConf", "$localStorage"];
  function Survey($http, $q, $rootScope, $analytics, gplansConf, $localStorage) {
    var _userSurveyId; // todo: initialize this

    /**
    * @name Survey
    * @desc The factory to be returned
    * @memberOf gplans.survey.services.Survey
    */
    var Survey = {
      getAnswers: getAnswers };


    return Survey;

    /////////////////////
    function _postprocessingAnswers(answers) {
      var processedAnswers = {};
      var problems = {};
      var userSurveyAnswers = answers.reduce(function (res, curr) {
        res[curr.question] = curr.answer_choice;
        return res;
      }, {});

      // stomach discomfort
      if (userSurveyAnswers[11] === 33 || userSurveyAnswers[11] === 34) {
        problems['stomach'] = 'stomach discomfort';
      }

      // diabetes
      if (userSurveyAnswers[7] === 18 || userSurveyAnswers[7] === 19) {
        problems['diabetes'] = 'diabetes';
      }

      // heart desease
      if (userSurveyAnswers[8] < 23) {
        problems['heart'] = 'heart disease';
      }

      // low energy
      if (userSurveyAnswers[9] > 25) {
        problems['energy'] = 'low energy';
      }

      // mood swings
      if (userSurveyAnswers[10] > 28) {
        problems['mood'] = 'mood swings';
      }

      if (userSurveyAnswers[1] > 1) {
        problems['sleep'] = 'sleep';
      }

      if (userSurveyAnswers[15] != 41) {
        problems['allergies'] = 'allergies';
        if (userSurveyAnswers[15] == 49) {
          problems['allergies'] += ',shellfish';
        }
        if (userSurveyAnswers[15] == 50) {
          problems['allergies'] += ',other';
        }
        if (userSurveyAnswers[15] == 42) {
          problems['allergies'] += ',dairy';
        }
        if (userSurveyAnswers[15] == 43) {
          problems['allergies'] += ',eggs';
        }
        if (userSurveyAnswers[15] == 44) {
          problems['allergies'] += ',peanuts';
        }
        if (userSurveyAnswers[15] == 45) {
          problems['allergies'] += ',tree nuts';
        }
        if (userSurveyAnswers[15] == 46) {
          problems['allergies'] += ',soy';
        }
        if (userSurveyAnswers[15] == 47) {
          problems['allergies'] += ',wheat';
        }
        if (userSurveyAnswers[15] == 48) {
          problems['allergies'] += ',fish';
        }
      }

      if (userSurveyAnswers[2] == 4) {
        problems['craving'] = 'craving';
      }

      if (userSurveyAnswers[14] != 36) {
        problems['restrictions'] = 'restrictions';
        if (userSurveyAnswers[14] == 39) {
          problems['restrictions'] += ',paleo';
        }
        if (userSurveyAnswers[14] == 38) {
          problems['restrictions'] += ',vegan';
        }
        if (userSurveyAnswers[14] == 37) {
          problems['restrictions'] += ',vegetarian';
        }
        if (userSurveyAnswers[14] == 40) {
          problems['restrictions'] += ',pescetarian';
        }
      }

      processedAnswers.userSurveyAnswers = userSurveyAnswers;
      processedAnswers.problems = problems;
      return processedAnswers;
    }

    function getAnswers(_userSurveyId) {
      // todo: _userSurveyId should be replaced with internal one that should be initialized right way
      return $http.get(gplansConf.API_URL + '/api/v1/usersurveys/' + _userSurveyId + '/surveyanswers/').
      then(function (res) {
        return _postprocessingAnswers(res.data);
      });
    }
  }
})();